import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import BookCover from '../components/BookCover';
import { Toaster, toast } from 'sonner';
import { Heart, Loader2, Trash2, ArrowLeft } from 'lucide-react';
import { loginWithGoogle } from '../utils/auth';

import { BACKEND_URL, API } from '../utils/api';
import { authFetch, clearToken } from '../utils/session';
const R2_URL = process.env.REACT_APP_R2_URL || BACKEND_URL + "/api/static";

const WishlistPage = () => {
  const navigate = useNavigate();
  const [wishlistSlugs, setWishlistSlugs] = useState([]);
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    Promise.all([
      authFetch(`${API}/auth/me`, {  }).then(r => r.ok ? r.json() : null),
      authFetch(`${API}/user/wishlist`, {  }).then(r => r.ok ? r.json() : []),
      fetch(`${API}/books`).then(r => r.json()),
    ]).then(([u, wl, bks]) => {
      setUser(u);
      setWishlistSlugs(wl || []);
      const mapped = (bks || []).map(b => ({ ...b, id: b.book_id || b.slug, coverUrl: `${R2_URL}/books/${b.imageFolder}/cover.webp` }));
      setBooks(mapped.filter(b => (wl || []).includes(b.slug)));
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const removeFromWishlist = async (slug) => {
    await authFetch(`${API}/user/wishlist/${slug}`, { method: 'DELETE' });
    setWishlistSlugs(prev => prev.filter(s => s !== slug));
    setBooks(prev => prev.filter(b => b.slug !== slug));
    toast.success('Eliminado de favoritos');
  };

  const addToCart = async (slug) => {
    await authFetch(`${API}/user/cart/${slug}`, { method: 'POST' });
    toast.success('Agregado al carrito');
  };

  if (loading) return <div className="min-h-dvh flex items-center justify-center"><Loader2 className="size-6 animate-spin text-muted-foreground" /></div>;

  if (!user) {
    return (
      <div className="min-h-dvh bg-background font-sans">
        <Header onSearchClick={() => navigate('/')} searchText="" />
        <div className="max-w-md mx-auto px-6 pt-20 text-center">
          <Heart className="size-10 text-muted-foreground/30 mx-auto mb-3" />
          <p className="text-muted-foreground text-sm mb-4">Inicia sesión para ver tus favoritos</p>
          <button onClick={() => loginWithGoogle('/favoritos')} className="h-10 px-5 rounded-xl bg-foreground text-background text-sm font-medium">Iniciar sesión con Google</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-dvh bg-background font-sans">
      <Toaster position="top-center" />
      <Header onSearchClick={() => navigate('/')} searchText="" />
      <div className="max-w-4xl mx-auto px-6 pt-6 pb-16">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-6">
          <ArrowLeft className="size-4" /> Volver
        </button>
        <h1 className="text-xl font-bold mb-6">Mis Favoritos</h1>
        {books.length === 0 ? (
          <div className="text-center py-16">
            <Heart className="size-10 text-muted-foreground/30 mx-auto mb-3" />
            <p className="text-muted-foreground text-sm">Aún no tienes favoritos</p>
            <p className="text-muted-foreground/50 text-xs mt-1">Toca el corazón en la página de cada libro</p>
            <button onClick={() => navigate('/')} className="mt-4 text-sm text-foreground font-medium hover:underline">Explorar libros</button>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {books.map(book => (
              <div key={book.slug} className="group">
                <button onClick={() => navigate(`/libro/${book.slug}`)} className="w-full text-left">
                  <div className="aspect-[3/4] rounded-lg overflow-hidden mb-2 group-hover:scale-105 transition-transform duration-200 shadow-sm">
                    <BookCover book={book} hideTitle />
                  </div>
                  <p className="text-xs font-medium truncate">{book.title}</p>
                  <p className="text-xs text-emerald-600 font-medium">${book.price?.toFixed(2)} USD</p>
                </button>
                <div className="flex items-center gap-1 mt-1.5">
                  <button onClick={() => addToCart(book.slug)} className="flex-1 h-7 rounded-lg bg-foreground text-background text-[10px] font-medium hover:bg-foreground/90 transition-colors">
                    Agregar al carrito
                  </button>
                  <button onClick={() => removeFromWishlist(book.slug)} className="h-7 w-7 rounded-lg border border-border flex items-center justify-center text-muted-foreground/40 hover:text-red-500 hover:border-red-200 transition-colors">
                    <Trash2 className="size-3" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default WishlistPage;
